import { z } from "zod";
import type { GrupoLembradoLogin } from "../tiposAutenticacaoJwt";

// ------------------------------- CONSTANTS -------------------------------
const CHAVE_GRUPO_LEMBRADO = "space_login_grupo";
const schemaGrupoLembrado = z.object({
	grupo: z.object({ id: z.number().int().nonnegative(), nome: z.string() }),
	identificacao: z.discriminatedUnion("tipo", [
		z.object({ tipo: z.literal("codigo"), valor: z.string().regex(/^\d{4}$/) }),
		z.object({ tipo: z.literal("slug"), valor: z.string().min(1) }),
	]),
});

// -------------------------------- HELPERS --------------------------------
function ehGrupoLembradoLogin(valor: unknown): valor is GrupoLembradoLogin {
	return schemaGrupoLembrado.safeParse(valor).success;
}

// ------------------------------- FUNCTIONS -------------------------------
export function lerGrupoLembradoLogin(): GrupoLembradoLogin | null {
	try {
		const valor = globalThis.localStorage.getItem(CHAVE_GRUPO_LEMBRADO);
		if (valor === null) return null;
		const dados: unknown = JSON.parse(valor);
		if (ehGrupoLembradoLogin(dados)) return dados;
	} catch {
		// Armazenamento indisponível ou conteúdo inválido equivale a preferência ausente.
	}
	removerGrupoLembradoLogin();
	return null;
}

export function salvarGrupoLembradoLogin(dados: Readonly<GrupoLembradoLogin>): void {
	try {
		globalThis.localStorage.setItem(
			CHAVE_GRUPO_LEMBRADO,
			JSON.stringify({
				grupo: { id: dados.grupo.id, nome: dados.grupo.nome },
				identificacao: { tipo: dados.identificacao.tipo, valor: dados.identificacao.valor },
			}),
		);
	} catch {
		// A preferência é opcional e não pode impedir a autenticação.
	}
}

export function removerGrupoLembradoLogin(): void {
	try {
		globalThis.localStorage.removeItem(CHAVE_GRUPO_LEMBRADO);
	} catch {
		// A tela ainda deve permitir informar outro grupo.
	}
}
